import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack, Badge, Link } from "@chakra-ui/react";
import { Calendar, Info, Smartphone, Link as LinkIcon, ShieldCheck } from "lucide-react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import { formatDate } from "utils/dateFormatter";

const ViewAppVersionDrawer = ({ isOpen, onClose, appVersion }) => {
  if (!appVersion) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={
        <Text fontSize="2xl" fontWeight="bold">
          App Version Details
        </Text>
      }
      bodyContent={
        <Flex direction="column" p={8} width="100%">
          <Flex justifyContent="space-between" alignItems="center" mb={2}>
            <Box>
              <Text fontSize="2xl" fontWeight="bold" textTransform="capitalize">
                {appVersion.platform}
              </Text>
             
            </Box>

            <Badge
              colorScheme={appVersion.maintenance_mode ? "red" : "green"}
              borderRadius="full"
              px={3}
              py={1}
            >
              {appVersion.maintenance_mode ? "Maintenance ON" : "Active"}
            </Badge>
          </Flex>

          <Flex mt={2} alignItems="center">
            <Icon as={Calendar} boxSize={4} color="gray.500" mr={2} />
            <Text fontSize="sm" color="gray.500">
              Date Added: {formatDate(appVersion.created_at)}
            </Text>
          </Flex>

          <Divider my={6} />

          <Flex direction="column" p={2}>
            <Box mb={6}>
              <Stack spacing={4}>
                <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Smartphone} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Platform: {appVersion.platform}
                  </Text>
                </Flex>

                <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Info} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Latest Version: {appVersion.latest_version}
                  </Text>
                </Flex>

                <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={ShieldCheck} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Minimum Supported Version: {appVersion.min_supported_version}
                  </Text>
                </Flex>

                <Box border="1px" borderColor="gray.300" borderRadius="md" p={4}>
                  <Flex alignItems="center" mb={2}>
                    <Icon as={LinkIcon} mr={2} color="gray.400" />
                    <Text fontWeight="600" color="gray.600" fontSize="sm">
                      Store URL
                    </Text>
                  </Flex>
                  <Link
                    href={appVersion.store_url}
                    isExternal
                    color="blue.500"
                    wordBreak="break-all"
                    fontSize="sm"
                  >
                    {appVersion.store_url}
                  </Link>
                </Box>

                <Flex alignItems="center" border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Maintenance Mode:{" "}
                    <Badge ml={2} colorScheme={appVersion.maintenance_mode ? "red" : "green"}>
                      {appVersion.maintenance_mode ? "Enabled" : "Disabled"}
                    </Badge>
                  </Text>
                </Flex>
              </Stack>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ViewAppVersionDrawer;